import { useContext } from 'react';
import { toCurrency, toFormattedDate } from "../../../utilities/FormatHelpers";
import { AccountContext } from "../AccountContext";

export default function EncourageCustomerToPayMore() {
    const { previousBillingPeriod } = useContext(AccountContext);

    return (
        <>
            {previousBillingPeriod && previousBillingPeriod.boostedPayment &&
                <div className="ui card">
                    <div className="custom-card-header">Encourage Customer to Pay More</div>
                    <div className="content">
                        <div>
                            <p>Boosted Payment: {toCurrency(previousBillingPeriod.boostedPayment.value)}</p>
                            {previousBillingPeriod.deltaBoostedPayment &&
                                <p>Delta Boosted Payment: {toCurrency(previousBillingPeriod.deltaBoostedPayment.value)}</p>
                            }
                            {previousBillingPeriod.recommendedExtraPayment &&
                                <p>Recommended Extra Payment: {toCurrency(previousBillingPeriod.recommendedExtraPayment.value)}</p>
                            }
                            {previousBillingPeriod.dynamicMinimumPayment &&
                                <p>Dynamic Minimum Payment: {toCurrency(previousBillingPeriod.dynamicMinimumPayment.value)}</p>
                            }
                        </div>
                    </div>
                </div>
            }
        </>);
}